import { useState, useEffect } from 'react'
import { FiRefreshCw, FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo, FiTarget, FiChevronDown, FiChevronRight, FiX } from 'react-icons/fi'
import api from '../utils/api'

const AY_AD = ['', 'Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık']

const fmtNum = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const fmtInt = (v) => Number(v || 0).toLocaleString('tr-TR')
const fmtTL = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'
const fmtPct = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'
const fmtCell = (v, fmt) => {
  if (v == null) return '—'
  if (fmt === 'tl' || fmt === 'money') return fmtTL(v)
  if (fmt === 'int') return fmtInt(v)
  if (fmt === 'num') return fmtNum(v)
  if (fmt === 'pct') return fmtPct(v)
  if (fmt === 'lt') return fmtNum(v) + ' Lt'
  return String(v)
}

const UYARI_STYLES = {
  danger:  { bg: 'bg-red-50 dark:bg-red-900/20',     border: 'border-red-400',    text: 'text-red-800 dark:text-red-200',     icon: FiAlertCircle,   iconCls: 'text-red-600' },
  warning: { bg: 'bg-amber-50 dark:bg-amber-900/20', border: 'border-amber-400',  text: 'text-amber-800 dark:text-amber-200', icon: FiAlertTriangle, iconCls: 'text-amber-600' },
  oneri:   { bg: 'bg-indigo-50 dark:bg-indigo-900/20', border: 'border-indigo-400', text: 'text-indigo-800 dark:text-indigo-200', icon: FiTarget,    iconCls: 'text-indigo-600' },
  success: { bg: 'bg-green-50 dark:bg-green-900/20', border: 'border-green-400',  text: 'text-green-800 dark:text-green-200', icon: FiCheckCircle,   iconCls: 'text-green-600' },
  info:    { bg: 'bg-blue-50 dark:bg-blue-900/20',   border: 'border-blue-400',   text: 'text-blue-800 dark:text-blue-200',   icon: FiInfo,          iconCls: 'text-blue-600' },
}

const ROW_BG = {
  danger: 'bg-red-50 dark:bg-red-900/20',
  orange: 'bg-orange-50 dark:bg-orange-900/20',
  yellow: 'bg-yellow-50 dark:bg-yellow-900/20',
  green:  'bg-green-50 dark:bg-green-900/20',
  info:   'bg-blue-50 dark:bg-blue-900/20',
}

function CariHareketModal({ cari, onClose }) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [openYil, setOpenYil] = useState({})
  const [openAy, setOpenAy] = useState({})

  useEffect(() => {
    if (!cari) return
    setLoading(true)
    const params = new URLSearchParams()
    if (cari.vkn_tckn) {
      if (cari.vkn_tckn.length === 11 && /^\d+$/.test(cari.vkn_tckn)) params.append('tckn', cari.vkn_tckn)
      else params.append('vkn', cari.vkn_tckn)
    }
    params.append('musteri', cari.musteri || '')
    // Bakiye row'undaki sube etiketini gonder (hizli filtre - sadece o subelere sor)
    if (cari.sube) params.append('sube', cari.sube)
    api.get(`/ai-analiz/cari-hareket?${params}`)
      .then(({ data }) => {
        setData(data)
        // Son yili default ac
        if (data.yillar && data.yillar[0]) setOpenYil({ [data.yillar[0].yil]: true })
      })
      .catch(e => console.error(e))
      .finally(() => setLoading(false))
  }, [cari])

  if (!cari) return null
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
        <div className="flex items-start justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100 truncate">{cari.musteri}</h3>
            <p className="text-[11px] text-gray-500 dark:text-gray-400">{cari.sube} {cari.vkn_tckn ? `· VKN/TCKN: ${cari.vkn_tckn}` : ''}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 p-1"><FiX size={18}/></button>
        </div>
        {loading ? (
          <div className="p-8 text-center text-sm text-gray-500">Hareketler yükleniyor...</div>
        ) : !data || !data.yillar?.length ? (
          <div className="p-8 text-center text-sm text-gray-500">Hareket bulunamadı</div>
        ) : (
          <>
            <div className="px-4 py-3 grid grid-cols-3 gap-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 text-xs">
              <div><div className="text-gray-500">Toplam Borç</div><div className="font-semibold text-red-600">{fmtTL(data.toplam_borc)}</div></div>
              <div><div className="text-gray-500">Toplam Alacak</div><div className="font-semibold text-green-600">{fmtTL(data.toplam_alacak)}</div></div>
              <div><div className="text-gray-500">Net ({data.toplam_hareket} hareket)</div>
                <div className={`font-semibold ${data.net_bakiye > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmtTL(Math.abs(data.net_bakiye))} {data.net_bakiye > 0 ? '(Borç)' : '(Alacak)'}</div>
              </div>
            </div>
            <div className="overflow-auto flex-1">
              {data.yillar.map(y => (
                <div key={y.yil} className="border-b border-gray-100 dark:border-gray-700">
                  <button onClick={() => setOpenYil(p => ({...p, [y.yil]: !p[y.yil]}))}
                    className="w-full px-4 py-2 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700/50 text-sm">
                    <div className="flex items-center gap-2">
                      {openYil[y.yil] ? <FiChevronDown size={14}/> : <FiChevronRight size={14}/>}
                      <span className="font-semibold">{y.yil}</span>
                    </div>
                    <div className="flex gap-3 text-[11px]">
                      <span className="text-red-600">B: {fmtTL(y.borc)}</span>
                      <span className="text-green-600">A: {fmtTL(y.alacak)}</span>
                      <span className={`font-semibold ${y.net > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmtTL(Math.abs(y.net))}</span>
                    </div>
                  </button>
                  {openYil[y.yil] && y.aylar.map(a => {
                    const ayKey = `${y.yil}-${a.ay}`
                    return (
                      <div key={a.ay} className="ml-4 border-l border-gray-200 dark:border-gray-700">
                        <button onClick={() => setOpenAy(p => ({...p, [ayKey]: !p[ayKey]}))}
                          className="w-full px-3 py-1.5 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700/50 text-xs">
                          <div className="flex items-center gap-2">
                            {openAy[ayKey] ? <FiChevronDown size={12}/> : <FiChevronRight size={12}/>}
                            <span>{AY_AD[a.ay]} ({a.hareketler.length})</span>
                          </div>
                          <div className="flex gap-2 text-[10px]">
                            <span className="text-red-600">B: {fmtTL(a.borc)}</span>
                            <span className="text-green-600">A: {fmtTL(a.alacak)}</span>
                          </div>
                        </button>
                        {openAy[ayKey] && (
                          <table className="w-full text-[11px] ml-2">
                            <thead className="bg-gray-50 dark:bg-gray-900/30">
                              <tr>
                                <th className="px-2 py-1 text-left">Tarih</th>
                                <th className="px-2 py-1 text-left">Şube</th>
                                <th className="px-2 py-1 text-left">Açıklama</th>
                                <th className="px-2 py-1 text-left">Fatura</th>
                                <th className="px-2 py-1 text-right">Borç</th>
                                <th className="px-2 py-1 text-right">Alacak</th>
                              </tr>
                            </thead>
                            <tbody>
                              {a.hareketler.map((h, i) => (
                                <tr key={i} className="border-b border-gray-50 dark:border-gray-700/30">
                                  <td className="px-2 py-1">{h.tarih}</td>
                                  <td className="px-2 py-1 text-gray-600">{h.sube}</td>
                                  <td className="px-2 py-1 truncate max-w-xs" title={h.aciklama}>{h.aciklama || '—'}</td>
                                  <td className="px-2 py-1">{h.fatura_no || '—'}</td>
                                  <td className="px-2 py-1 text-right tabular-nums text-red-600">{h.borc > 0 ? fmtTL(h.borc) : '—'}</td>
                                  <td className="px-2 py-1 text-right tabular-nums text-green-600">{h.alacak > 0 ? fmtTL(h.alacak) : '—'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    )
                  })}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default function AIAnaliz() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [openInfo, setOpenInfo] = useState({})
  const [selectedCari, setSelectedCari] = useState(null)

  const load = async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/ai-analiz')
      setData(data)
    } catch (e) { console.error(e) }
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  return (
    <div className="p-3 md:p-5">
      <div className="sticky top-0 z-20 -mx-3 md:-mx-5 px-3 md:px-5 py-3 mb-4 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur border-b border-gray-200 dark:border-gray-700 flex items-center justify-between gap-2 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-lg md:text-xl font-bold text-gray-800 dark:text-gray-100">🧠 Yapay Zeka Analiz</h1>
          <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 truncate">Danışman bakış açısıyla geçmiş veri analizi · {data && new Date(data.generated_at).toLocaleString('tr-TR')}</p>
        </div>
        <button onClick={load} disabled={loading} className={`p-2 rounded-lg ${loading ? 'text-primary-400' : 'text-gray-500 hover:text-primary-600 hover:bg-primary-50 dark:hover:bg-gray-800'}`}>
          <FiRefreshCw size={16} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      {loading && !data && <div className="text-center py-20 text-gray-400">Analiz hazırlanıyor...</div>}

      {data?.sections?.map((sec, i) => (
        <div key={i} className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 mb-4">
          <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-3 pb-2 border-b dark:border-gray-700">{sec.title}</h2>

          {sec._render === 'yorum' ? (
            <div className="space-y-2">
              {(sec.uyarilar || []).map((u, j) => {
                const s = UYARI_STYLES[u.tip] || UYARI_STYLES.info
                const IconEl = s.icon
                return (
                  <div key={j} className={`flex gap-3 p-3 rounded-lg border-l-4 ${s.bg} ${s.border}`}>
                    <IconEl className={`${s.iconCls} mt-0.5 flex-shrink-0`} size={18}/>
                    <div className="flex-1 min-w-0">
                      <div className="text-[10px] font-bold uppercase tracking-wide mb-1 text-gray-500">{u.kategori}</div>
                      <p className={`text-sm font-medium ${s.text}`}>{u.mesaj}</p>
                      {u.detay && <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">{u.detay}</p>}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <>
              {sec.kpis && sec.kpis.length > 0 && (
                <div className={`grid grid-cols-2 gap-3 mb-4 ${
                  sec.kpis.length >= 6 ? 'md:grid-cols-6' :
                  sec.kpis.length === 5 ? 'md:grid-cols-5' :
                  sec.kpis.length === 4 ? 'md:grid-cols-4' :
                  sec.kpis.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'
                }`}>
                  {sec.kpis.map((kpi, j) => (
                    <div key={j} className="bg-gray-50 dark:bg-gray-900 rounded-lg p-3 border border-gray-100 dark:border-gray-700">
                      <div className="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium">{kpi.label}</div>
                      <div className="text-xl font-bold text-gray-800 dark:text-gray-100 mt-1">{fmtCell(kpi.value, kpi.format)}</div>
                    </div>
                  ))}
                </div>
              )}

              {(sec.tables || []).map((tbl, j) => (
                <div key={j} className="mt-3">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="text-xs font-medium text-gray-600 dark:text-gray-300 flex-1">{tbl.title}</h3>
                    {tbl.info && (
                      <button onClick={() => setOpenInfo(p => ({...p, [`${i}-${j}`]: !p[`${i}-${j}`]}))}
                        className="text-gray-400 hover:text-blue-600 p-1"><FiInfo size={12}/></button>
                    )}
                  </div>
                  {openInfo[`${i}-${j}`] && tbl.info && (
                    <div className="mb-2 bg-blue-50 dark:bg-blue-900/20 border-l-2 border-blue-400 px-3 py-2 text-[11px] text-gray-700 dark:text-gray-300 whitespace-pre-line rounded-r">{tbl.info}</div>
                  )}
                  {tbl.rows.length === 0 ? (
                    <p className="text-xs text-gray-400 italic">Veri yok</p>
                  ) : (
                    <div className="overflow-auto max-h-[60vh] border border-gray-100 dark:border-gray-700 rounded">
                      <table className="w-full text-xs anlik-table">
                        <thead className="sticky top-0 z-20">
                          <tr className="bg-gray-50 dark:bg-gray-700">
                            {tbl.columns.map((c, ci) => (
                              <th key={c.key} className={`px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300 ${c.format ? 'text-right' : ''} bg-gray-50 dark:bg-gray-700 ${ci === 0 ? 'sticky left-0 z-30' : ''}`}>{c.label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {tbl.rows.map((row, k) => {
                            const rowBg = ROW_BG[row._row_color] || ''
                            const isBakiye = row.musteri != null && (row.tur === 'Alacak' || row.tur === 'Borç')
                            return (
                              <tr key={k} className={`border-b border-gray-50 dark:border-gray-700 ${rowBg} ${isBakiye ? 'cursor-pointer hover:bg-primary-50 dark:hover:bg-primary-900/20' : ''}`}
                                  onClick={isBakiye ? () => setSelectedCari(row) : undefined}
                                  title={isBakiye ? 'Hareketleri gör' : undefined}>
                                {tbl.columns.map((c, ci) => (
                                  <td key={c.key} className={`px-2 py-1 text-gray-700 dark:text-gray-300 ${c.format ? 'text-right tabular-nums' : ''} ${ci === 0 ? `sticky left-0 z-[1] ${rowBg || 'bg-white dark:bg-gray-800'}` : ''} ${isBakiye && c.key === 'musteri' ? 'text-primary-600 dark:text-primary-400 underline decoration-dotted' : ''}`}>
                                    {fmtCell(row[c.key], c.format)}
                                  </td>
                                ))}
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      ))}
      <CariHareketModal cari={selectedCari} onClose={() => setSelectedCari(null)} />
    </div>
  )
}
